import { SectionsKey } from "~/constants/enum";

const PageStruct = {
    id: 'thank-you',
    useLayout: true,
    children: [
        { id: SectionsKey.ThankYou, order: 1 },
        { id: SectionsKey.OfferProducts, order: 2 }
    ]
};

export default PageStruct;
